import React, {Component} from 'react';

import { ResponsivePie } from '@nivo/pie'


class PieChart extends Component {
    render() {
        return (
            <ResponsivePie
                data={this.props.data}
                id={"label"}
                margin={{ top: 30, right: 90, bottom: 30, left: 90 }}
                colors={["#5969ff", "#ff407b", "#ffc750", "#2ec551", "#ef172c", "#ffc108", "#25d5f2", "#F5D0A9", "#0489B1", "#5F04B4" ,"#CC2EFA", "#819FF7", "#FACC2E"]}
                // colors= {{"scheme":"paired"}}
                enableArcLabels={false}
                borderWidth={0}
                arcLinkLabel={function(e){return e.label+" ("+e.value+")"}}
                innerRadius={0.5}
                padAngle={0.7}
                cornerRadius={3}
                activeInnerRadiusOffset={5}
                activeOuterRadiusOffset={7}
                borderColor={{ from: 'color', modifiers: [ [ 'darker', 0.2 ] ] }}
                arcLinkLabelsSkipAngle={6}
                arcLinkLabelsTextOffset={3}
                arcLinkLabelsTextColor="#333333"
                arcLinkLabelsOffset={1}
                arcLinkLabelsDiagonalLength={8}
                arcLinkLabelsStraightLength={13}
                arcLinkLabelsThickness={3}
                arcLinkLabelsColor={{ from: 'color' }}
                arcLabelsRadiusOffset={0.6}
                arcLabelsSkipAngle={8}
                animate={true}
                motionStiffness={90}
                motionDamping={15}                
            />
        )
    }
    
}


export default PieChart;